import {ComponentType, SVGProps} from 'react';

import {MainWalletBase} from '@cosmos-kit/core';
import {wallets as cosmostation} from '@cosmos-kit/cosmostation-extension';
import {wallets as keplr} from '@cosmos-kit/keplr-extension';
import {wallets as keplrMobile} from '@cosmos-kit/keplr-mobile';
import {wallets as leap} from '@cosmos-kit/leap-extension';
import {wallets as metamaskLeap} from '@cosmos-kit/leap-metamask-cosmos-snap';
import {wallets as leapMobile} from '@cosmos-kit/leap-mobile';
import {wallets as ledger} from '@cosmos-kit/ledger';
import {engineName, isMobile} from 'react-device-detect';

import {
  CosmosKitWalletType,
  WalletProvider,
  Web3AuthLoginProvider,
} from 'app/types/providers';

import {Icons} from './icons';

//import {wallets as trust} from '@cosmos-kit/trust-mobile';
//import {wallets as okxwallet} from '@cosmos-kit/okxwallet-extension';
//import {wallets as station} from '@cosmos-kit/station-extension';
//import {wallets as xdefi} from '@cosmos-kit/xdefi-extension';
//import {wallets as cosmostationMobile} from '@cosmos-kit/cosmostation-mobile';
//import {wallets as metamask} from '@cosmos-kit/cosmos-extension-metamask';

export type WalletInfo = {
  name: string;
  Icon?: ComponentType<SVGProps<SVGSVGElement>>;
  isInstalled?: (mainWalletBase: MainWalletBase) => boolean;
  isMobile?: boolean;
  isDisabled?: boolean;
};

type CosmosKitWallet = WalletInfo & {
  wallets: MainWalletBase[];
};

export const COSMOS_KIT_WALLETS_INFO: Record<
  CosmosKitWalletType,
  CosmosKitWallet
> = {
  'keplr-extension': {
    name: 'Keplr',
    Icon: Icons.keplr,
    isInstalled: () => !!window.keplr,
    wallets: keplr,
  },
  'leap-extension': {
    name: 'Leap',
    Icon: Icons.leap,
    isInstalled: () => !!window.leap,
    wallets: leap,
  },
  'keplr-mobile': {
    name: 'Keplr',
    Icon: Icons.keplr,
    isMobile: true,
    wallets: keplrMobile,
    isInstalled: () => isMobile && !window.keplr,
  },
  'leap-cosmos-mobile': {
    name: 'Leap',
    Icon: Icons.leap,
    isMobile: true,
    wallets: leapMobile,
    isInstalled: () => isMobile && !window.leap,
  },
  'cosmostation-mobile': {
    name: 'Cosmostation',
    Icon: Icons.cosmoStation,
    isMobile: true,
    wallets: [], //cosmostationMobile,
    isDisabled: true,
  },
  'trust-mobile': {
    name: 'Trust Wallet',
    wallets: [], //trust,
    isMobile: true,
    isDisabled: true,
  },
  'cosmos-extension-metamask': {
    name: 'MetaMask',
    Icon: Icons.metamask2,
    isInstalled: () => !!window.ethereum?.isMetaMask,
    wallets: metamaskLeap,
    isDisabled: true,
  },
  'leap-metamask-cosmos-snap': {
    name: 'MetaMask',
    Icon: Icons.metamask2,
    isInstalled: () => !!window.ethereum?.isMetaMask,
    wallets: metamaskLeap,
  },
  'cosmostation-extension': {
    name: 'Cosmostation',
    Icon: Icons.cosmoStation,
    isInstalled: () => !!window.cosmostation,
    wallets: cosmostation,
  },
  'ledger-web-usb-hid': {
    name: 'Ledger',
    Icon: Icons.leadger,
    wallets: ledger,
    isMobile: isMobile,
    isInstalled: () => true,
    isDisabled: engineName !== 'Blink',
  },
  'okxwallet-extension': {
    name: 'OKX Wallet',
    wallets: [], //okxwallet,
    Icon: Icons.okx,
    isInstalled: () => !!window.okxwallet,
    isDisabled: true,
  },
  'station-extension': {
    name: 'Station',
    wallets: [], //station,
    isInstalled: () => !!window.station,
    Icon: Icons.station,
    isDisabled: true,
  },
  'xdefi-extension': {
    name: 'XDEFI',
    wallets: [], //xdefi,
    Icon: Icons.xdefi,
    isInstalled: () => !!window.xfi,
    isDisabled: true,
  },
};

export const WEB3AUTH_WALLETS_INFO: Record<Web3AuthLoginProvider, WalletInfo> =
  {
    email_passwordless: {
      name: 'Email',
    },
    google: {
      name: 'Google',
      Icon: Icons.google,
    },
    discord: {
      name: 'Discord',
      Icon: Icons.discord,
    },
    reddit: {
      name: 'Reddit',
      Icon: Icons.reddit,
    },
    apple: {
      name: 'Apple',
      Icon: Icons.apple,
    },
    twitter: {
      name: 'Twitter',
      Icon: Icons.xCorp,
    },
  };

export const WALLETS_INFO: Record<
  WalletProvider | CosmosKitWalletType | Web3AuthLoginProvider,
  WalletInfo
> = {
  web3_auth: {
    name: 'Web3Auth',
  },
  cosmos_kit: {
    name: 'CosmosKit',
  },
  ...COSMOS_KIT_WALLETS_INFO,
  ...WEB3AUTH_WALLETS_INFO,
};
